import HttpStatusCode from "../../enums/HttpStatusCode";
import UnProcessableEntityException from "../../exceptions/UnProcessableEntityException";
import AccountService from "../AccountService";
import ApplicationException from "../../exceptions/ApplicationException";

export default class ResponseMiddleware {

    onResponse(response) {

        if(response.status >= 200 && response.status < 300){
            return response;
        }

        let error;

        switch (response.status){
            case HttpStatusCode.BAD_REQUEST:
                error = new Error('BAD_REQUEST');
            break;
            case HttpStatusCode.UNAUTHORIZED:
                AccountService.signOut();
                location.href = '/signin';
                break;
            case HttpStatusCode.NOT_FOUND:
                error = new Error('NOT_FOUND');
                break;
            case HttpStatusCode.UNPROCESSABLE_ENTITY:
                error = new UnProcessableEntityException(response);
                break;
            case HttpStatusCode.INTERNAL_SERVER_ERROR:
                error = new Error('Server Error');
                break;
            default:
                error = new ApplicationException(response);
            break;
        }

        throw error;
    }
}